import {Component, Vue} from "vue-property-decorator";

@Component
class MainContainer extends Vue {
  render() {
    return (
      <div class="main-container">
        <div class="main-container_inner">
          {this.$slots.default}
        </div>
      </div>
    );
  }
}

export {MainContainer};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0e4b2519/main-container.tsx" });